import { render, staticRenderFns } from "./JudgesSearchBarComponent.vue?vue&type=template&id=12a6b621"
import script from "./JudgesSearchBarComponent.vue?vue&type=script&lang=js"
export * from "./JudgesSearchBarComponent.vue?vue&type=script&lang=js"
import style0 from "./JudgesSearchBarComponent.vue?vue&type=style&index=0&id=12a6b621&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports